import { getPreserveExpectedErrorsForCallerContext } from "../../../../utils/apolloErrorPolicy";

export const CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED_CODE =
  "CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED";
export const CMP_EVENT_INVENTORY_CAPACITY_UNAVAILABLE_CODE =
  "CMP_EVENT_INVENTORY_CAPACITY_UNAVAILABLE";

export const eventSalesRegistrationCreateApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: [
      CMP_EVENT_INVENTORY_CAPACITY_UNAVAILABLE_CODE,
    ],
  });

// CSV exports show their own error message on the page (APBOT, Oct 2026).
// Unexpected failures are still reported; none redirect to the error page.
export const eventSalesExportApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: ["BAD_USER_INPUT"],
  });

// Manage Events status actions (publish, cancel, close, set to draft,
// delete) show a refusal such as "can't be deleted, use Cancel Event" in the
// page feedback instead of the error page (APBOT, Oct 2026).
export const eventStatusActionApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: ["BAD_USER_INPUT"],
  });

// Event Sales actions that show their own error (save draft, email invoice,
// PDF, card payment start, waitlist) stay on the page when the backend
// refuses, instead of opening the error page (Oct 15 2026 sweep).
export const eventSalesCallerHandledApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: [
      "BAD_USER_INPUT",
      CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED_CODE,
    ],
  });

export const eventSalesHostedCheckoutApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: [
      CMP_EVENT_HOSTED_CHECKOUT_ACTION_BLOCKED_CODE,
    ],
  });
